module.exports = __webpack_public_path__ + "img/crSD_FTD.82345a31.svg";